import axios from "axios";
import { notify } from "./notification";
import { getAccessToken, getAltAddress } from "./auth";
import { baseUrl } from "../config/urls";
import store from "../../store/store";

const brevo_key = process.env.REACT_APP_BREVO_ID || "";



export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const sendVerificationEmail = async (email: string): Promise<any> => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/user/send_verification_email?email=${email}`,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    notify(`Error sending verification email`, "error");
  }
};

export const verifyEmailToken = async (token: string): Promise<any> => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/user/verify_email?verification_token=${token}`,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    if (response?.status === 200) {
      return response;
    } else {
      throw new Error('Email not verified');
    }
  } catch (error) {
    notify(`Error Verifying the email , Please try again in sometime`, "error");
  }
};





export const sendFileShareEmail = async (emailIds: string[], cid: string, setMailAddress: any) => {
  try {

    const receiversList = emailIds.map(email => ({ email }));

    if (emailIds.length > 0) {
      const options = {
        method: "POST",
        url: "https://api.brevo.com/v3/smtp/email",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          "api-key": brevo_key,
        },
        data: {
          sender: {
            "name": "Lighthouse",
            "email": "hello@lighthouseweb3.xyz"
          },
          to: receiversList,
          templateId: 3,
          params: { CID: cid, FILE_TYPE: "Encrypted", USER_ADDRESS: getAltAddress(), LINK: `https://decrypt.mesh3.network/${cid}` }
        },
      };

      axios
        .request(options)
        .then(function (response) {
          //
          notify("File Shared Successfully", "success");
          setMailAddress([]);
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  } catch (error) {
    //
  }
};




export const sendSubscriptionEmail = async (email: string) => {
  try {
    if (validateEmail(email)) {
      const options = {
        method: "POST",
        url: "https://api.brevo.com/v3/smtp/email",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          "api-key": brevo_key,
        },
        data: {
          sender: {
            "name": "Lighthouse",
            "email": "hello@lighthouseweb3.xyz"
          },
          to: [{ email }],
          templateId: 4,
          tags: ["filesdapp-subscription"],
        },
      };

      axios
        .request(options)
        .then(function (response) {
          //
          notify("Email Submitted", "success");
        })
        .catch(function (error) {
          console.error(error);
        });
    } else {
      notify(`Error: Enter a valid email address`, "error");
    }
  } catch (error) {
    console.error(error);
  }
};


export const sendWelcomeEmail = async () => {
  try {
    const email = store?.getState()?.["balance"]?.["email"];
    if (validateEmail(email)) {
      const options = {
        method: "POST",
        url: "https://api.brevo.com/v3/smtp/email",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          "api-key": brevo_key,
        },
        data: {
          sender: {
            "name": "Lighthouse",
            "email": "hello@lighthouseweb3.xyz"
          },
          to: [{ email }],
          templateId: 2,
        },
      };

      axios
        .request(options)
        .then(function (response) {
          //
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  } catch (error) {
    console.error(error);
  }
};